import React, {useRef, useState} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {Field} from 'formik';
import styles from './styles.module.scss';
import markSubmitField from "../../assets/check-black.svg";
import editButton from "../../assets/edit-24px.svg";
import percent from "../../assets/percentage.svg";

const FieldInputEditMode = ({
                              fieldId,
                              type = 'text',
                              label = null,
                              containerCustomStyles = null,
                              onChange,
                              handleDataSubmit,
                              showPercentIcon = false,
                              calcTypeId,
                              value,
                              dirty,
                              ...rest
                            }) => {

  const handleInputChange = ({form, field}) => e => {
    const value = e.target.value;
    if (onChange) {
      const changedValue = onChange(e);
      form.setFieldValue(field.name, changedValue);
    } else {
      form.setFieldValue(field.name, value);
    }
  };

  const [editMode, setEditMode] = useState(false);

  const useFocus = () => {
    const htmlElRef = useRef(null)
    const setFocus = () => {
      htmlElRef.current && htmlElRef.current.focus()
    }

    return [htmlElRef, setFocus]
  }
  const [inputRef, setInputFocus] = useFocus();

  const activateEditMode = () => {
    setEditMode(true)
    setInputFocus();
  }
  const deactivateEditMode = () => {
    setEditMode(false);
    if (dirty) {
      handleDataSubmit(calcTypeId, value);
    }
  }

  return (
    <div className={styles.fieldInputEditModeContainer}>
      <Field
        id={fieldId}
        name={fieldId}
      >
        {({form, field, meta}) => (
          <label className={classnames(styles.inputContainer, containerCustomStyles)}>
            <div className={classnames(styles.labelContainer, {[styles.errorLabel]: meta.error && meta.touched})}>
              {label}
            </div>
            <input
              className={classnames(styles.input, {[styles.showPercentIcon]: showPercentIcon}, editMode ? styles.editMode : styles.disabled, {[styles.errorBorder]: meta.error && meta.touched})}
              type={type}
              onChange={handleInputChange({form, field})}
              value={field.value}
              ref={inputRef}
              readOnly={!editMode}
              onBlur={deactivateEditMode}
              {...rest}
            />
            <div className={classnames(styles.errorMessageOff, {[styles.errorMessageOn]: meta.error && meta.touched})}>
              <p className={styles.errorText}>{meta.error}</p>
            </div>
            {showPercentIcon &&
            <img
              src={percent}
              alt="percent"
              className={styles.percentIcon}
            />
            }
          </label>
        )}
      </Field>
      {editMode &&
      <img
        src={markSubmitField}
        alt="submit"
        className={styles.submitButton}
        onClick={deactivateEditMode}
      />
      }
      {!editMode &&
      <img
        src={editButton}
        alt="edit"
        className={styles.editButton}
        onClick={activateEditMode}
      />
      }
    </div>
  );
};

FieldInputEditMode.propTypes = {
  fieldId: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  type: PropTypes.oneOf(['text', 'number', 'email', 'password', 'tel']),
  label: PropTypes.node,
  labelStyles: PropTypes.object,
  onChange: PropTypes.func,
};

export default FieldInputEditMode;
